import { render } from "./IconHelpMenu.vue?vue&type=template&id=498a8d8c"
import script from "./IconHelpMenu.vue?vue&type=script&lang=js"
export * from "./IconHelpMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__